// BillingSuccess.jsx
import { useEffect, useRef, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import api from '@mysimpledb/shared/config/axios';

const MAX_ATTEMPTS = 15;
const POLL_DELAY_MS = 1000;

function sleep(ms) {
  return new Promise((resolve) => {
    window.setTimeout(resolve, ms);
  });
}

export default function BillingSuccess() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [message, setMessage] = useState(
    'Finalizing your subscription…'
  );
  const cancelledRef = useRef(false);

  useEffect(() => {
    cancelledRef.current = false;

    const type = params.get('type');

    if (type !== 'subscription') {
      navigate('/account/billing', {
        replace: true,
        state: {
          fromStripe: false,
          error: 'Unknown billing completion type.',
        },
      });

      return () => {
        cancelledRef.current = true;
      };
    }

    (async () => {
      for (let attempt = 1; attempt <= MAX_ATTEMPTS; attempt += 1) {
        if (cancelledRef.current) return;

        try {
          const { data } = await api.get('/billing/notes/summary');

          const subscription = data?.billing?.subscription;

          if (
            data?.billing?.subscribed &&
            subscription?.status
          ) {
            navigate('/account/billing', {
              replace: true,
              state: {
                fromStripe: true,
                stripeData: {
                  plan: 'notes',
                  status: subscription.status,
                  currentPeriodEnd:
                    subscription.currentPeriodEnd,
                },
              },
            });

            return;
          }
        } catch (error) {
          // A webhook may still be processing. Continue polling unless this
          // component is unmounted.
          console.warn(
            'Billing finalization check failed:',
            error?.response?.data || error?.message
          );
        }

        setMessage(
          attempt < MAX_ATTEMPTS
            ? 'Payment received. Finalizing your subscription…'
            : 'Payment received. Your subscription is still being finalized.'
        );

        if (attempt < MAX_ATTEMPTS) {
          await sleep(POLL_DELAY_MS);
        }
      }

      if (!cancelledRef.current) {
        navigate('/account/billing', {
          replace: true,
          state: {
            fromStripe: true,
            stripeData: {
              plan: 'notes',
              status: 'processing',
              currentPeriodEnd: null,
            },
          },
        });
      }
    })();

    return () => {
      cancelledRef.current = true;
    };
  }, [navigate, params]);

  return <p>{message}</p>;
}
